import { Component } from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="error-boundary">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mx-auto mb-6">
              <AlertTriangle size={28} className="text-red-400" />
            </div>
            <h2 className="font-heading text-[24px] font-semibold text-[#1F2937] mb-2">Bir sorun oluştu</h2>
            <p className="text-sm text-[#5F6B76] mb-6">
              Sayfa yüklenirken beklenmeyen bir hata oluştu. Lütfen sayfayı yenilemeyi deneyin.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#1F6E7A] text-white text-sm font-medium hover:bg-[#185960] transition-colors"
                data-testid="error-reload-btn"
              >
                <RefreshCw size={14} /> Yenile
              </button>
              <a
                href="/"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#E7E5E4] text-sm font-medium text-[#5F6B76] hover:bg-[#F5F3EF] transition-colors"
                data-testid="error-home-btn"
              >
                <Home size={14} /> Ana Sayfa
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
